"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _constants = require("ComposeUI/lib/constants");

var DEFAULTS = {
  seenCompositorOnboarding: false,
  seenReadOnlyAlert: false,
  seenOnboarding: false,
  seenDraftSunset: 0,
  status: _constants.RequestStatus.UNINITIALIZED
};

var UserSettings = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(UserSettings, _Record);

  function UserSettings() {
    (0, _classCallCheck2.default)(this, UserSettings);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UserSettings).apply(this, arguments));
  }

  (0, _createClass2.default)(UserSettings, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      return new UserSettings({
        seenCompositorOnboarding: data.seenCompositorOnboarding,
        seenReadOnlyAlert: data.seenReadOnlyAlert,
        seenOnboarding: data.seenOnboarding,
        seenDraftSunset: data.seenDraftSunset,
        status: _constants.RequestStatus.SUCCEEDED
      });
    }
  }]);
  return UserSettings;
}((0, _immutable.Record)(DEFAULTS));

exports.default = UserSettings;
module.exports = exports.default;